import { COVERAGE_TABS } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import { createCoverageParamsSelector, createCoverageSelector } from '../../../common/coverage/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getBrowserCoverage = (store) => store.apps.analytics.vdc.coverage.browser;

export const browserCoverageSelector = createCoverageSelector({
  coverageStore: getBrowserCoverage,
  source: 'vdc',
  productSubArea: TRACKING_SUB_AREA[COVERAGE_TABS.browsers.trackEvent],
});

export const getParams = createCoverageParamsSelector(
  filtersSelectors.getCoverageFiltersParams,
  getBrowserCoverage,
);
